module.exports = __webpack_public_path__ + "img/bancomer.c4a2e8f.png";